/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import {mediaHelper} from 'utils';
import {Breakpoints} from "../../constants/Breakpoints";

// background-color: ${Colors.GRAY[5]};
const BaseWrapper = styled.div`
  height: 100%;
  background-color1: ${Colors.RED};
  background-color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  ${mediaHelper.lg`
    padding: 0;
  `}
`;

const BaseWrapper_BKP = styled.div`
  height: 100%;
  background-color: ${Colors.GRAY[5]};

  ${mediaHelper.lg`
    padding: 0;
  `}
`;

// background-color: ${Colors.Alpha(Colors.PRIMARY, 0.7)};
const Background = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  width: 100vw;
  height 975px;
  background-color: ${Colors.Alpha(Colors.PRIMARY, 1)};
  background-color-white: ${Colors.WHITE};
  border-bottom-left-radius: 24px;
  z-index: 0;

  ${mediaHelper.xxs`
    height: 1300px;
   `}

  ${mediaHelper.xs`
    height: 1200px;
  `}

  ${mediaHelper.sm`
    height: 780px;
  `}

  ${mediaHelper.md`
    height: 720px;
  `}

  ${mediaHelper.lg`
    height: 620px;
  `}

   ${mediaHelper.xl`
    left: 150px;
    `}
  
  @media (max-width: ${Breakpoints.xl}) {
    left: 0px;
  }
`;

export { BaseWrapper, Background };
